import client from './client'
import type {
  Voucher,
  CreateVoucherPayload,
  UpdateVoucherPayload,
  ValidateVoucherPayload,
  VoucherValidationResult,
} from '@/types/voucher'

const BASE = '/organizer/events'

export async function getEventVouchers(eventSlug: string): Promise<Voucher[]> {
  const { data } = await client.get<{ data: Voucher[] }>(`${BASE}/${eventSlug}/vouchers`)
  return data.data
}

export async function createVoucher(
  eventSlug: string,
  payload: CreateVoucherPayload,
): Promise<Voucher> {
  const { data } = await client.post<{ data: Voucher }>(
    `${BASE}/${eventSlug}/vouchers`,
    payload,
  )
  return data.data
}

export async function getVoucher(
  eventSlug: string,
  voucherId: number,
): Promise<Voucher> {
  const { data } = await client.get<{ data: Voucher }>(
    `${BASE}/${eventSlug}/vouchers/${voucherId}`,
  )
  return data.data
}

export async function updateVoucher(
  eventSlug: string,
  voucherId: number,
  payload: UpdateVoucherPayload,
): Promise<Voucher> {
  const { data } = await client.put<{ data: Voucher }>(
    `${BASE}/${eventSlug}/vouchers/${voucherId}`,
    payload,
  )
  return data.data
}

export async function deleteVoucher(
  eventSlug: string,
  voucherId: number,
): Promise<void> {
  await client.delete(`${BASE}/${eventSlug}/vouchers/${voucherId}`)
}

export async function validateVoucher(
  payload: ValidateVoucherPayload,
): Promise<VoucherValidationResult> {
  const { data } = await client.post<VoucherValidationResult>(
    '/participant/vouchers/validate',
    payload,
  )
  return data
}
